import { AllupBetlineFragment } from '@graphqlTypes/sitecore';
import { BetPickDetail } from '@mobx/stores/kol/kol-store';
import { allUpItemFragment, DeepReadonly } from '@src/utils/type-utils';
import { useTranslation } from 'next-i18next';
import React from 'react';
import AllUpItemButton from './AllUpItemButton';
import RegularItemButton from './RegularItemButton';

type Props = {
    betpickDetail: DeepReadonly<BetPickDetail>;
    raceNo?: string;
    curAllUpItem?: allUpItemFragment | null;
    isAllUpItem?: boolean;
    // isAllUpStrike?: boolean;
    AllUpDataItem?: AllupBetlineFragment | null;
};

const BetPickButton = ({
    raceNo,
    betpickDetail,
    isAllUpItem,
    AllUpDataItem,
    curAllUpItem,
}: Props) => {
    return isAllUpItem ? (
        <AllUpItemButton
            raceNo={raceNo ?? ''}
            curAllUpItem={curAllUpItem ?? null}
            AllUpDataItem={AllUpDataItem}
        />
    ) : (
        <RegularItemButton betpickDetail={betpickDetail} />
    );
};

export default BetPickButton;
